module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("For mothers and daughters everywhere:")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Through ups and downs,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("through laughter and tears,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("the bond that connects us remains")]), _vm._v(" "), _c('p', {
    staticClass: "ded-bot"
  }, [_vm._v("forever strong.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("For my own mother:")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Your love has made me a better person.")]), _vm._v(" "), _c('p', {
    staticClass: "ded-bot"
  }, [_vm._v("Thanks for being my biggest supporter!")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And finally, for my precious baby girl:")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Every day I watch you grow,")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("I am amazed at the wonder of life.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("And when you smile at me—")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Ah!")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("It doesn’t get better than that.")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("I hope to enrich your life")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("the way my mother did mine.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d39b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 69
// module chunks = 0